import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import config from 'react-global-configuration';
import CoreLink from '../CoreLink';
import './style.scss';
var Breadcrumbs = function Breadcrumbs(_ref) {
  var includeCurrent = _ref.includeCurrent,
    hideHome = _ref.hideHome;
  var breadcrumbs = useSelector(function (state) {
    return state.getIn(['entity', 'breadcrumbs']);
  });
  var _useSelector = useSelector(function (state) {
      var entityId = state.getIn(['entity', 'entityId']);
      var entityType = state.getIn(['entity', 'entityType']);
      var entity = state.getIn([entityType, entityId]);
      if (!entity) {
        return {
          currentTitle: null,
          currentUrl: null
        };
      }
      var title = entity.getIn(['title', 0, 'value']);
      var url = entity.getIn(['paths', config.get('DEFAULT_LANGUAGE')]);
      return {
        currentTitle: title,
        currentUrl: url
      };
    }),
    currentTitle = _useSelector.currentTitle,
    currentUrl = _useSelector.currentUrl;
  var breadcrumbItems = breadcrumbs.map(function (item, index) {
    var url = item.get('url');
    var title = item.get('title');
    if (hideHome && index === 0) {
      return;
    }
    return /*#__PURE__*/React.createElement("li", {
      key: url,
      className: "Breadcrumbs__item",
      property: "itemListElement",
      typeof: "ListItem"
    }, /*#__PURE__*/React.createElement(CoreLink, {
      property: "item",
      typeof: "WebPage",
      href: url
    }, /*#__PURE__*/React.createElement("span", {
      property: "name"
    }, title)), /*#__PURE__*/React.createElement("meta", {
      property: "position",
      content: index
    }));
  });
  if (includeCurrent && currentTitle && currentUrl) {
    var index = breadcrumbItems.size + 1;
    breadcrumbItems = breadcrumbItems.push( /*#__PURE__*/React.createElement("li", {
      key: currentUrl,
      className: "Breadcrumbs__item",
      property: "itemListElement",
      typeof: "ListItem"
    }, /*#__PURE__*/React.createElement(CoreLink, {
      property: "item",
      typeof: "WebPage",
      href: currentUrl
    }, /*#__PURE__*/React.createElement("span", {
      property: "name"
    }, currentTitle)), /*#__PURE__*/React.createElement("meta", {
      property: "position",
      content: index
    })));
  }
  return /*#__PURE__*/React.createElement("ol", {
    className: "Breadcrumbs",
    vocab: "https://schema.org/",
    typeof: "BreadcrumbList"
  }, breadcrumbItems);
};
Breadcrumbs.defaultProps = {
  includeCurrent: false,
  hideHome: false
};
Breadcrumbs.propTypes = {
  includeCurrent: PropTypes.bool,
  hideHome: PropTypes.bool
};
export default Breadcrumbs;